import { getPadding, setRect, getRect } from '../views/common/utils';
import { BORDER_WIDTH } from '../constants/main';
import { isObject } from '@progress/kendo-vue-common';
/** @hidden */
export var useSlotExpand = function useSlotExpand(slot, _scheduler, config) {
  var timeout = undefined;
  var initialHeight = 0;
  var getInitialHeight = function getInitialHeight() {
    if (!slot) {
      return;
    }
    var element = slot.$el;
    if (!element) {
      return;
    }
    element.style.minHeight = null;
    initialHeight = element.clientHeight;
  };
  var expand = function expand() {
    if (!config || !slot) {
      return;
    }
    var element = slot.$el;
    if (!element || !slot.bv.items.length) {
      return;
    }
    var slotPadding = getPadding(element);
    var highest = 0;
    var existing = slot.cSlot.items.filter(function (i) {
      return i.refTo;
    });
    existing.forEach(function (item) {
      var currentItem = slot.bv.items.find(function (i) {
        return i.uid === item.uid;
      });
      if (!currentItem) {
        return;
      }
      var height = getRect(currentItem.getElement()).height;
      highest += height;
    });
    var minHeight = existing.length * BORDER_WIDTH * 2 + highest - (slotPadding || 0) + (isObject(config) && config.offsetTop ? config.offsetTop : 0) + (isObject(config) && config.offsetBottom ? config.offsetBottom : 0);
    if (existing.length) {
      if (minHeight > initialHeight - slotPadding) {
        setRect(element, {
          height: minHeight
        }, true);
      }
    } else if (element) {
      element.style.minHeight = null;
    }
  };
  getInitialHeight();
  expand();
};